export default __webpack_public_path__ + "static/Metal_Dinosaur_Gate-1fb7cfe7ec2cf34813a7306452c975af.png";